import * as React from "react";

const ShippingIconDryIce: React.FC = () => {
    return (
        <svg width="19" height="22" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 27"> <g fill="#002554" stroke="#002554" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"> <path d="M12 13.5V1M15.3 3.2 12 5.1s-1.6-.9-3.3-1.9M12 13.5V26M8.7 23.8c1.7-1 3.3-1.9 3.3-1.9l3.3 1.9M12 13.5 1 19.8M1.3 15.8l3.3 1.9v3.8M12 13.5l11-6.3M22.7 11.2c-1.7-1-3.3-1.9-3.3-1.9V5.5M12 13.5l11 6.3M19.4 21.5v-3.8s1.6-.9 3.3-1.9M12 13.5 1 7.2M4.6 5.5v3.8l-3.3 1.9" /> </g> </svg>
    );
};

export default React.memo(ShippingIconDryIce);
